import { Text, useTheme } from '@fluentui/react';
import React from 'react';

interface IProps {
    title?: string | JSX.Element;
    style?: React.CSSProperties;
    childStyle?: React.CSSProperties;
    className?: string;
}

const Card: React.FC<IProps> = (props) => {
    const theme = useTheme();
    return (
        <div
            style={{
                backgroundColor: theme.palette.white,
                borderRadius: 2,
                display: 'flex',
                ...props.style,
            }}
            className={`ms-depth-8 ${props.className ? props.className : ''}`}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    padding: 18,
                }}
            >
                {props.title ? (
                    <Text styles={{ root: { marginBottom: 10 } }} variant="mediumPlus">
                        {props.title}
                    </Text>
                ) : null}
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        ...props.childStyle,
                    }}
                >
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default Card;
